export const emailValidation = (email) => {
  const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (email.match(regExp)) {
    return true;
  }
  return false;
};

export const priceFormater = (textInputDonation) => {
  const value = textInputDonation.length > 2 ? textInputDonation.slice(3).replaceAll('.', '') : textInputDonation.replaceAll('.', '');
  if(value.length===0){
    return;
  }
  return new Intl.NumberFormat('id-ID', {
    style: 'currency', currency: 'IDR', minimumFractionDigits: 0,
  }).format(value);
};
